"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectSurfaceActionsOption')(function selectSurfaceActionsOption(option, actionCollection, actionKey, checked, state) {
    var optionState = state.optionState;
    if (checked) {
        if (actionCollection.indexOf(actionKey) == -1) {
            actionCollection.push(actionKey);
        }
    }
    else {
        var index = actionCollection.indexOf(actionKey);
        if (index >= 0) {
            actionCollection.splice(index, 1);
        }
    }
    optionState[option] = actionCollection;
}));
//# sourceMappingURL=selectSurfaceActionsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-surface-actions-option/lib/actions/selectSurfaceActionsOption.js
// module id = 5239
// module chunks = 2